import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import '../vant-variables.less'

Vue.use(Vant)


//
// import Vue from "vue";
// import { Button,Toast,Popup  } from 'vant';
//
// const list = [
//   Button,
//   Toast,
//   Popup
// ]
// //循环注册组件
// list.forEach(ele => {
//   Vue.use(ele)
// })


/*
* this.$toast('123')
*
*
*
* */
